<div class="cart-summary">
  <span>
    <a
      (click)="isCollapsed = !isCollapsed"
      data-testing-id="promo-collapse-link"
      class="btn btn-link btn-content-toggle p-0"
      [attr.aria-expanded]="!isCollapsed"
      aria-controls="promo-code-input"
      >{{ 'dias.shopping_cart.promotional_code.heading' | translate }} <fa-icon [icon]="['fas', 'angle-down']"
    /></a>
    <!-- <fa-icon [icon]="['fas', isCollapsed ? 'angle-down' : 'angle-up']" class="float-right" /> -->
  </span>

  <ish-error-message [error]="promotionError$ | async" [toast]="toast()" />

  @if (displaySuccessMessage) {
  <ish-success-message message="shopping_cart.promotion.qualified_promo.text" [toast]="toast()" />
  }

  <div
    class="cart-apply-promo form-inline justify-content-between"
    [ngbCollapse]="isCollapsed"
    data-testing-id="promo-code-form"
    id="promo-code-input"
  >
    <input
      [formControl]="codeInput"
      (keydown.enter)="submitPromotionCode()"
      class="form-control"
      type="text"
      [maxlength]="codeMaxLength"
      [attr.aria-label]="'shopping_cart.promotional_code.label' | translate"
      aria-labelledby="promotion-code-button"
      [placeholder]="'dias.shopping_cart.promotional_code.label' | translate"
      class="text-center input-btn"
    />

    <button
      type="button"
      class="btn btn-secondary apply-btn"
      [disabled]="!codeInput.valid"
      (click)="submitPromotionCode()"
    >
      {{ 'shopping_cart.promotion.apply.button.label' | translate }}
    </button>
  </div>
</div>
